// Generated by purs version 0.15.15
var subscriptionRedirect = function (status) {
    var $2 = status === "FreeTrialMode" || status === "Paid";
    if ($2) {
        return "home";
    };
    var $3 = status === "PaymentFailed" || (status === "PaymentNotYetConfigured" || status === "Canceled");
    if ($3) {
        return "chooseSubscription";
    };
    return "none";
};
export {
    subscriptionRedirect
};
//# sourceMappingURL=index.js.map
